import {
  ActionLimiterUtils
} from "./chunk-ARWLRO3D.mjs";

// lib/hooks/use-search-form.ts
import { useCallback, useMemo, useState } from "react";
var useSearchForm = ({
  defaultValues,
  search,
  validate,
  wait
}) => {
  const [values, setValues] = useState(defaultValues);
  const [status, setStatus] = useState("idle");
  const debounced = useMemo(
    () => ActionLimiterUtils.debounce(async (v) => {
      const isValid = validate?.(v) ?? true;
      if (!isValid) return;
      setStatus("searching");
      await search(v);
      setStatus("idle");
    }, wait ?? 500),
    []
  );
  const handleChange = useCallback(
    async (v, method = "debounce") => {
      setValues(v);
      if (method === "debounce") {
        setStatus("debouncing");
        await debounced(v);
      } else {
        await search(v);
      }
    },
    [setValues]
  );
  return {
    values,
    status,
    handleChange
  };
};

export {
  useSearchForm
};
